<ng-select #select [items]="data" [virtualScroll]="true" [placeholder]="defaultLabel" [loading]="isLoading()"
  [bindLabel]="bindLabel" [typeahead]="returnSearchSubject()" [multiple]="multiple || multipleCheckBox" [formControl]="formControl"
  (scrollToEnd)="onScrollToEnd()" (change)="onChange($event)" (blur)="onBlur($event)" (clear)="onClear()"
  (close)="onClose()" [appendTo]="appendTo" [clearable]="clearable" [closeOnSelect]="!multipleCheckBox"
  [ngClass]="{ 'multi-checkbox-select': multipleCheckBox, 'red-color': redColor, 'valid-color' : validColor}"
>
  <ng-container *ngIf="!multipleCheckBox">
    <ng-template *ngIf="itemTemplate" ng-option-tmp let-item="item" let-index="index">
      <ng-template *ngTemplateOutlet="itemTemplate; context: {item: item, index: index}"></ng-template>
    </ng-template>
  </ng-container>

  <ng-container *ngIf="multipleCheckBox">
    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
      <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/>{{item[bindLabel]}}
    </ng-template>
  </ng-container>
</ng-select>
